import {main_phaser} from "./MadnesApp";
import {
    madnes_get_alpha, madnes_get_angle,
    madnes_get_pos_x,
    madnes_get_pos_y, madnes_get_scale_x, madnes_get_scale_y,
    madnes_key_exist,
    madnes_set_alpha,
    madnes_set_angle,
    madnes_set_pos,
    madnes_set_scale,
    madnes_set_visible
} from "./madnes_object";
import {madnes_eval, madnes_get_currtime} from "./madnes";
import {he} from "./madnes_variables";

export let move_buffer = [];
export let fall_buffer = [];
export let coin_move_buffer = [];
export let scale_buffer = [];
export let alpha_buffer = [];
export let rotate_buffer = [];
export let functions_buffer = [];

export function madnes_add_to_render(func) {
    for(var i  = 0; i < functions_buffer.length; i++)
    {
        if(functions_buffer[i] == func)
        {
            return;
        }
    }

    functions_buffer[functions_buffer.length] = func;
}

export function madnes_rem_from_render(func) {
    var tmp = [];

    for(var i  = 0; i < functions_buffer.length; i++)
    {
        if(functions_buffer[i] != func)
        {
            tmp[tmp.length] = functions_buffer[i];
        }
    }

    functions_buffer = tmp;
}

export function madnes_render() {
//	main_phaser.debug.inputInfo(30, 30);

    // Move
    if(move_buffer.length > 0)
    {
        var toremove = new Array();
        for(var pos = 0; pos < move_buffer.length; pos++)
        {
            var now = madnes_get_currtime();
            var dur = now - move_buffer[pos].start_time;
            if(dur > move_buffer[pos].total_time)
            {
                // END
                madnes_set_pos(move_buffer[pos].key, move_buffer[pos].end_x, move_buffer[pos].end_y);
                if(typeof move_buffer[pos].callback != "undefined")
                {
                    if(typeof move_buffer[pos].callback == "function")
                    {
                        move_buffer[pos].callback();
                    }
                    else
                    {
                        madnes_eval(move_buffer[pos].callback);
                    }
                }
                toremove[toremove.length] = pos;
            }
            else
            {
                // REPOS
                var proc_pos = ( ( 100 / move_buffer[pos].total_time ) * dur ) / 100;
                var x = ( ( move_buffer[pos].end_x - move_buffer[pos].start_x ) * proc_pos ) + move_buffer[pos].start_x;
                var y = ( ( move_buffer[pos].end_y - move_buffer[pos].start_y ) * proc_pos ) + move_buffer[pos].start_y;
                madnes_set_pos(move_buffer[pos].key, x, y);
                madnes_set_visible(move_buffer[pos].key, 1);
            }
        }
        var tmp = [];
        for(var pos = 0; pos < move_buffer.length; pos++)
        {
            if(toremove.indexOf(pos) === -1)
            {
                tmp[tmp.length] = move_buffer[pos]
            }
        }
        move_buffer = tmp;
    }
    // Move end



    // Fall
    if(fall_buffer.length > 0)
    {
        var toremove = new Array();
        for(var pos = 0; pos < fall_buffer.length; pos++)
        {
            var now = madnes_get_currtime();
            var dur = now - fall_buffer[pos].start_time;
            if(dur > fall_buffer[pos].total_time)
            {
                // END
                madnes_set_pos(fall_buffer[pos].key, fall_buffer[pos].end_x, fall_buffer[pos].end_y);
                if(typeof fall_buffer[pos].callback != "undefined")
                {
                    if(typeof fall_buffer[pos].callback == "function")
                    {
                        fall_buffer[pos].callback();
                    }
                    else
                    {
                        madnes_eval(fall_buffer[pos].callback);
                    }
                }
                toremove[toremove.length] = pos;
            }
            else
            {
                // REPOS
                var proc_pos = ( ( 100 / fall_buffer[pos].total_time ) * dur ) / 100;
                //var x = ( ( fall_buffer[pos].end_x - fall_buffer[pos].start_x ) * proc_pos ) + fall_buffer[pos].start_x;
                //var y = ( ( fall_buffer[pos].end_y - fall_buffer[pos].start_y ) * proc_pos ) + fall_buffer[pos].start_y;
                var grav = 9.8 * 100000;

                var x = (
                    0.5 *
                    grav *
                    Math.pow( fall_buffer[pos].total_time * proc_pos  , 2 ) *
                    (
                        fall_buffer[pos].end_x - fall_buffer[pos].start_x
                    ) / (
                        0.5 *
                        grav *
                        Math.pow( fall_buffer[pos].total_time, 2 )
                    )
                ) + fall_buffer[pos].start_x;

                var y = (
                    0.5 *
                    grav *
                    Math.pow( fall_buffer[pos].total_time * proc_pos  , 2 ) *
                    (
                        fall_buffer[pos].end_y - fall_buffer[pos].start_y
                    ) / (
                        0.5 *
                        grav *
                        Math.pow( fall_buffer[pos].total_time, 2 )
                    )
                ) + fall_buffer[pos].start_y;

                madnes_set_pos(fall_buffer[pos].key, x, y);
            }
        }
        var tmp = [];
        for(var pos = 0; pos < fall_buffer.length; pos++)
        {
            if(toremove.indexOf(pos) === -1)
            {
                tmp[tmp.length] = fall_buffer[pos];
            }
        }
        fall_buffer = tmp;
    }
    // Fall end



    // Move coin
    if(coin_move_buffer.length > 0)
    {
        var toremove = new Array();
        for(var pos = 0; pos < coin_move_buffer.length; pos++)
        {
            var now = madnes_get_currtime();
            var dur = now - coin_move_buffer[pos].start_time;
            if(dur > coin_move_buffer[pos].total_time)
            {
                // END
                madnes_set_pos(coin_move_buffer[pos].key, coin_move_buffer[pos].end_x, coin_move_buffer[pos].end_y);
                if(typeof coin_move_buffer[pos].callback != "undefined")
                {
                    if(typeof coin_move_buffer[pos].callback == "function")
                    {
                        coin_move_buffer[pos].callback();
                    }
                    else
                    {
                        madnes_eval(coin_move_buffer[pos].callback);
                    }
                }
                toremove[toremove.length] = pos;
            }
            else
            {
                // REPOS
                var proc_pos = ( ( 100 / coin_move_buffer[pos].total_time ) * dur ) / 100;

                var pos_p = 0;

                if(proc_pos <= 0.33)
                {
                    pos_p = proc_pos * 3;

                    var x_perc = ( coin_move_buffer[pos].middle_x - coin_move_buffer[pos].start_x ) * pos_p;
                    x_perc = ( ( 100 / ( coin_move_buffer[pos].middle_x - coin_move_buffer[pos].start_x ) ) * x_perc ) / 100;
                    x_perc = x_perc * ( Math.PI / 2 );
                    x_perc = 1 - Math.cos(x_perc);

                    var y_perc = ( coin_move_buffer[pos].middle_y - coin_move_buffer[pos].start_y ) * pos_p;
                    y_perc = ( ( 100 / ( coin_move_buffer[pos].middle_y - coin_move_buffer[pos].start_y ) ) * y_perc ) / 100;
                    y_perc = y_perc * ( Math.PI / 2 );
                    y_perc = Math.sin(y_perc);

                    var x = ( ( coin_move_buffer[pos].middle_x - coin_move_buffer[pos].start_x ) * x_perc ) + coin_move_buffer[pos].start_x;
                    var y = ( ( coin_move_buffer[pos].middle_y - coin_move_buffer[pos].start_y ) * y_perc ) + coin_move_buffer[pos].start_y;

                    //madnes_add_sprite("tmp_" + Math.random(), "coin_sprite", x, y, 1, 0.5, 0.5);
                }
                else
                {
                    pos_p = ( proc_pos - 0.33 ) * 1.5;

                    var x_perc = ( coin_move_buffer[pos].end_x - coin_move_buffer[pos].middle_x ) * pos_p;
                    x_perc = ( ( 100 / ( coin_move_buffer[pos].end_x - coin_move_buffer[pos].middle_x ) ) * x_perc ) / 100;
                    x_perc = ( 1 - x_perc ) * ( Math.PI / 2 );
                    x_perc = Math.cos(x_perc);

                    var y_perc = ( coin_move_buffer[pos].end_y - coin_move_buffer[pos].middle_y ) * pos_p;
                    y_perc = ( ( 100 / ( coin_move_buffer[pos].end_y - coin_move_buffer[pos].middle_y ) ) * y_perc ) / 100;
                    y_perc = ( 1 - y_perc ) * ( Math.PI / 2 );
                    y_perc = 1 - Math.sin(y_perc);

                    var x = ( ( coin_move_buffer[pos].end_x - coin_move_buffer[pos].middle_x ) * x_perc ) + coin_move_buffer[pos].middle_x;
                    var y = ( ( coin_move_buffer[pos].end_y - coin_move_buffer[pos].middle_y ) * y_perc ) + coin_move_buffer[pos].middle_y;


                    //madnes_add_sprite("tmp_" + Math.random(), "coin_sprite", x, y, 1, 0.5, 0.5);
                }

                madnes_set_pos(coin_move_buffer[pos].key, x, y);
            }
        }
        var tmp = [];
        for(var pos = 0; pos < coin_move_buffer.length; pos++)
        {
            if(toremove.indexOf(pos) === -1)
            {
                tmp[tmp.length] = coin_move_buffer[pos];
            }
        }
        coin_move_buffer = tmp;
    }
    // Move coin end

    // Scale
    if(scale_buffer.length > 0)
    {
        var toremove = new Array();
        for(var pos = 0; pos < scale_buffer.length; pos++)
        {
            var now = madnes_get_currtime();
            var dur = now - scale_buffer[pos].start_time;

            if(dur > scale_buffer[pos].total_time)
            {
                // END
                madnes_set_scale(scale_buffer[pos].key, scale_buffer[pos].end_x, scale_buffer[pos].end_y);
                if(typeof scale_buffer[pos].callback != "undefined")
                {
                    if(typeof scale_buffer[pos].callback == "function")
                    {
                        scale_buffer[pos].callback();
                    }
                    else
                    {
                        madnes_eval(scale_buffer[pos].callback);
                    }
                }
                toremove[toremove.length] = pos;
            }
            else
            {
                // REPOS
                var proc_pos = ( ( 100 / scale_buffer[pos].total_time ) * dur ) / 100;
                var x = ( ( scale_buffer[pos].end_x - scale_buffer[pos].start_x ) * proc_pos ) + scale_buffer[pos].start_x;
                var y = ( ( scale_buffer[pos].end_y - scale_buffer[pos].start_y ) * proc_pos ) + scale_buffer[pos].start_y;
                madnes_set_scale(scale_buffer[pos].key, x, y);
            }
        }
        var tmp = [];
        for(var pos = 0; pos < scale_buffer.length; pos++)
        {
            if(toremove.indexOf(pos) === -1)
            {
                tmp[tmp.length] = scale_buffer[pos]
            }
        }
        scale_buffer = tmp;
    }
    // Scale end


    // Alpha
    if(alpha_buffer.length > 0)
    {
        var toremove = new Array();
        for(var pos = 0; pos < alpha_buffer.length; pos++)
        {
            var now = madnes_get_currtime();
            var dur = now - alpha_buffer[pos].start_time;
            if(dur > alpha_buffer[pos].total_time)
            {
                // END
                madnes_set_alpha(alpha_buffer[pos].key, alpha_buffer[pos].end_a);
                if(typeof alpha_buffer[pos].callback != "undefined")
                {
                    if(typeof alpha_buffer[pos].callback == "function")
                    {
                        alpha_buffer[pos].callback();
                    }
                    else
                    {
                        madnes_eval(alpha_buffer[pos].callback);
                    }
                }

                toremove[toremove.length] = pos;
            }
            else
            {
                // REPOS
                var proc_pos = ( ( 100 / alpha_buffer[pos].total_time ) * dur ) / 100;
                var a = ( ( alpha_buffer[pos].end_a - alpha_buffer[pos].start_a ) * proc_pos ) + alpha_buffer[pos].start_a;
                madnes_set_alpha(alpha_buffer[pos].key, a);
            }
        }
        var tmp = [];
        for(var pos = 0; pos < alpha_buffer.length; pos++)
        {
            if(toremove.indexOf(pos) === -1)
            {
                tmp[tmp.length] = alpha_buffer[pos]
            }
        }
        alpha_buffer = tmp;
    }
    // Alpha end

    // Rotate
    if(rotate_buffer.length > 0)
    {
        var toremove = new Array();
        for(var pos = 0; pos < rotate_buffer.length; pos++)
        {
            var now = madnes_get_currtime();
            var dur = now - rotate_buffer[pos].start_time;
            if(dur > rotate_buffer[pos].total_time)
            {
                // END
                var dir = rotate_buffer[pos].direction;
                if(dir > 0)
                {
                    dir = 1;
                }
                else
                {
                    dir = -1;
                }
                var ang = ( rotate_buffer[pos].start_a + rotate_buffer[pos].degrees * dir ) % 360;
                madnes_set_angle(rotate_buffer[pos].key, ang);

                if(typeof rotate_buffer[pos].callback != "undefined")
                {
                    if(typeof rotate_buffer[pos].callback == "function")
                    {
                        rotate_buffer[pos].callback();
                    }
                    else
                    {
                        madnes_eval(rotate_buffer[pos].callback);
                    }
                }

                toremove[toremove.length] = pos;
            }
            else
            {
                // REPOS
                var proc_pos = ( ( 100 / rotate_buffer[pos].total_time ) * dur ) / 100;

                var dir = rotate_buffer[pos].direction;
                if(dir > 0)
                {
                    dir = 1;
                }
                else
                {
                    dir = -1;
                }
                var ang = ( rotate_buffer[pos].start_a + rotate_buffer[pos].degrees * dir * proc_pos ) % 360;
                madnes_set_angle(rotate_buffer[pos].key, ang);

            }
        }
        var tmp = [];
        for(var pos = 0; pos < rotate_buffer.length; pos++)
        {
            if(toremove.indexOf(pos) === -1)
            {
                tmp[tmp.length] = rotate_buffer[pos]
            }
        }
        rotate_buffer = tmp;
    }
    // Rotate end

    // Functions
    for(var pos = 0; pos < functions_buffer.length; pos++)
    {
        if(typeof functions_buffer[pos] != "undefined")
        {
            if(typeof functions_buffer[pos] == "function")
            {
                functions_buffer[pos]();
            }
            else
            {
                madnes_eval(functions_buffer[pos]);
            }
        }
    }
    // Functions end

}

/**
 * @param {string} name
 * @param {?number} x
 * @param {?number} y
 * @param {number} total_time
 * @param {Function=} callback
 */
export function madnes_move_to(name, x, y, total_time, callback) {
    var start_x = madnes_get_pos_x(name);
    var start_y = madnes_get_pos_y(name);

    move_buffer[move_buffer.length] = {
        key: name,
        start_time: madnes_get_currtime(),
        start_x: start_x,
        start_y: start_y,
        end_x: (typeof x === 'undefined' || x === null) ? start_x : x,
        end_y: (typeof y === 'undefined' || y === null) ? start_y : y,
        total_time: total_time,
        callback: callback
    };
}

/**
 * @param {string} name
 * @param {number} x
 * @param {number} y
 * @param {number} total_time
 * @param {Function=} callback
 */
export function madnes_fall_to(name, x, y, total_time, callback) {
    var start_x = madnes_get_pos_x(name);
    var start_y = madnes_get_pos_y(name);

    fall_buffer[fall_buffer.length] = {
        key: name,
        start_time: madnes_get_currtime(),
        start_x: start_x,
        start_y: start_y,
        end_x: (typeof x == 'undefined' || x === null) ? start_x : x,
        end_y: (typeof y == 'undefined' || y === null) ? start_y : y,
        total_time: total_time,
        callback: callback
    }
}

/**
 * @param {string} name
 * @param {number} a
 * @param {number} total_time
 * @param {Function=} callback
 */
export function madnes_alpha_to(name, a, total_time, callback) {
    alpha_buffer[alpha_buffer.length] = {
        key: name,
        start_time: madnes_get_currtime(),
        start_a: madnes_get_alpha(name),
        end_a: a,
        total_time: total_time,
        callback: callback
    };
}

/**
 * @param {string} name
 * @param {*} x
 * @param {*} y
 * @param {*} total_time
 * @param {Function=} callback
 * @returns {undefined}
 */
export function madnes_scale_to(name, x, y, total_time, callback) {

    var start_x = madnes_get_scale_x(name);
    var start_y = madnes_get_scale_y(name);

    scale_buffer[scale_buffer.length] = {
        key: name,
        start_time: madnes_get_currtime(),
        start_x: start_x,
        start_y: start_y,
        end_x: (typeof x == 'undefined' || x === null) ? start_x : x,
        end_y: (typeof y == 'undefined' || y === null) ? start_y : y,
        total_time: total_time,
        callback: callback
    }
}

/**
 * @param {string} name
 * @param {number} degrees
 * @param {number} direction
 * @param {number} total_time
 * @param {Function=} callback
 */
export function madnes_rotate_to(name, degrees, direction, total_time, callback) {
    var start_a = madnes_get_angle(name);

    rotate_buffer[rotate_buffer.length] = {
        key: name,
        start_time: madnes_get_currtime(),
        start_a: start_a,
        degrees: (typeof degrees == 'undefined' || degrees === null) ? 0 : degrees,
        direction: (typeof direction == 'undefined' || direction === null) ? 1 : direction,
        total_time: total_time,
        callback: callback
    }
}

export function madnes_shake_screen(intensity, duration) {
    main_phaser.camera.shake(intensity, duration);
}

export function madnes_shake_screenXY(x, y, duration)
{
    main_phaser.camera.shakeXY(x, y, duration);
}

export function madnes_coin_move_to(name, x, y, total_time, callback) {

    var start_x = madnes_get_pos_x(name);
    var start_y = madnes_get_pos_y(name);

    if(x > start_x)
    {
        var middle_x = Math.round( ( ( x - start_x ) / 2 ) + start_x );
    }
    else
    {
        var middle_x = Math.round( ( ( start_x - x ) / 2 ) + x );
    }

    var middle_y = Math.round( ( he / 2 ) + ( Math.random() * 300 - 150 ) );

    coin_move_buffer[coin_move_buffer.length] = {
        key: name,
        start_time: madnes_get_currtime(),
        start_x: start_x,
        start_y: start_y,
        middle_x: middle_x,
        middle_y: middle_y,
        end_x: (typeof x == 'undefined' || x === null) ? start_x : x,
        end_y: (typeof y == 'undefined' || y === null) ? start_y : y,
        total_time: total_time,
        callback: callback
    }
}
